import { useEffect, useRef } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import BuildProperties from "@/envconfig/BuildProperties";
import { InfoIcon } from "lucide-react";
import { ButtonWithLoader } from "../ui/buttonwithloader";

mapboxgl.accessToken = BuildProperties.getMapBoxKey()

type Coordinates = {
  lat: number | any;
  lng: number| any;
};

type MapPickerProps = {
  initialLocation: Coordinates | any;
  onLocationSelect: (coords: Coordinates) => void | any;
  confirmHandler?: () => void;

};

const MapPicker = ({ initialLocation, onLocationSelect, confirmHandler=()=>{}}: MapPickerProps) => {
  const mapContainer = useRef<HTMLDivElement | null>(null);
  const map = useRef<mapboxgl.Map | null>(null);
  const marker = useRef<mapboxgl.Marker | null>(null);

  useEffect(() => {
    if (!mapContainer.current || map.current) return;

    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [initialLocation.lng, initialLocation.lat],
      zoom: 14
    });

    marker.current = new mapboxgl.Marker({ draggable: true })
      .setLngLat([initialLocation.lng, initialLocation.lat])
      .addTo(map.current);

    marker.current.on("dragend", () => {
      const lngLat = marker.current?.getLngLat();
      if (lngLat) {
        onLocationSelect({
          lat: lngLat.lat,
          lng: lngLat.lng
        });
      }
    });

  }, [initialLocation, onLocationSelect]);

  return (
    <>
    <div className="flex justify-start items-center gap-2">

      <InfoIcon className="w-4 h-4 text-flup-info" />
      <p>Hold and Drag Map Icons to select location on map. </p>

    </div>
    <div
      ref={mapContainer}
      style={{ width: "100%", height: "400px", borderRadius: "10px" }}
    />
    <ButtonWithLoader
    onClick={confirmHandler}
  className="w-full"
    >
      Confirm loaction
    </ButtonWithLoader>
     </>
  );
};

export default MapPicker;
